import axios from 'axios'

const API_PATH = 'api/v2/admins/banners'

const bannerFormData = (values) => {
  const formData = new FormData()
  Object.keys(values).forEach((key) => {
    const value = values[key]
    if (value !== null && value !== undefined && value !== '') formData.append(`banner[${key}]`, value)
  })
  return formData
}

const BannersApiV2 = {
  get     : (archived = false) => axios.get(API_PATH, { params: { archived: String(archived) } }),
  show    : (id) => axios.get(`${API_PATH}/${id}`),
  create  : (values) => axios.post(API_PATH, bannerFormData(values)),
  update  : (id, values) => axios.patch(`${API_PATH}/${id}`, bannerFormData(values)),
  restore : (id) => axios.post(`${API_PATH}/${id}/restore`),
  destroy : (id) => axios.delete(`${API_PATH}/${id}`)
}

export default BannersApiV2
